import React from 'react';
import SEOHead from '../components/SEOHead';
import { Check, Calculator, AlertTriangle, Copyright, RefreshCw } from 'lucide-react';

const Terms = () => {
  return (
    <>
      <SEOHead page="terms" />
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>
        
        <div className="bg-white p-6 rounded-lg shadow-sm mb-8">
          <p className="text-gray-700">
            Please read these terms and conditions carefully before using the Car Loan Payment Calculator. By using our calculator, you agree to be bound by these terms.
          </p>
        </div>
        
        <div className="space-y-6 text-gray-700">
          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Check className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Acceptance of Terms</h2>
            </div>
            <p>
              By accessing and using the Car Loan Payment Calculator, you accept and agree to be bound by these 
              Terms and Conditions. If you do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Calculator className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Use of Calculator</h2>
            </div>
            <p>
              Our car loan calculator is provided as a tool to assist in estimating car loan payments and costs.
              Results should be verified independently with your lender. We are not responsible for any financial 
              decisions made based on calculator results.
            </p>
            <p className="mt-3">
              The calculator provides estimates only and does not constitute an offer of credit. Actual loan terms, 
              interest rates, and eligibility are determined by lenders based on their own criteria.
            </p>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <AlertTriangle className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Disclaimer</h2>
            </div>
            <p>
              The car loan calculator is provided "as is" without warranty of any kind. We do not guarantee 
              the accuracy of results and are not liable for any damages arising from its use. Actual loan terms,
              interest rates, and fees may vary based on lender policies, your credit score, and other factors.
            </p>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Copyright className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Intellectual Property</h2>
            </div>
            <p>
              All content and functionality on this website is the exclusive property of Car Loan Payment Calculator 
              and is protected by international copyright laws. You may not reproduce, distribute, or create derivative
              works without our express permission.
            </p>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <RefreshCw className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Modifications</h2>
            </div>
            <p>
              We reserve the right to modify these terms at any time without prior notice. Continued use of the website 
              following any changes constitutes acceptance of the modified terms. It is your responsibility to review
              these terms periodically.
            </p>
          </section>
          
          <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mt-8">
            <p className="text-blue-800">
              Last updated: {new Date().toLocaleDateString('en-AU', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
            <p className="mt-2 text-blue-800">
              By using our Car Loan Payment Calculator, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;